/**
 *	map.conf.js
 */
 
import angular from 'angular';

import mapDirective from './map.directive.js';

import { directionsSetterComponent, DirectionsSetterCtrl } from './children/directions-setter/directions-setter.component';
import { highlightedBoundsComponent } from './children/highlighted-bounds/highlighted-bounds.component';
import infoWindow from './children/info-window/info-window.component.js';
import mapBoundsStateSetterComponent from './children/map-bounds-state-setter/map-bounds-state-setter.component.js';
import mapReadySetterComponent from './children/map-ready-setter/map-ready-setter.component.js';
import mapToCoordinatesPointerComponent from './children/map-to-coordinates-pointer/map-to-coordinates-pointer.component.js';
import { shopHighlighter } from './children/shop-highlighter/shop-highlighter.component.js';
import shopMarkerClicker from './children/shop-marker-clicker/shop-marker-clicker.component.js';
import shopMarkersDirective from './children/shop-markers/shop-markers.directive';
import shopsInBoundsDirective from './children/shops-in-bounds/shops-in-bounds.directive';
import userLocationMarkerDirective from './children/user-location-marker/user-location-marker.directive';

import MapHelperServ from './map-helper.serv.js';
import MapServ from './map.serv.js';

export default angular.module('google-map', [])
	.directive('map', mapDirective)

	.directive('directionsSetter', directionsSetterComponent)
	.controller('DirectionsSetterCtrl', DirectionsSetterCtrl)
	
	.directive('highlightedBounds', highlightedBoundsComponent)
	.directive('infoWindow', infoWindow)
	.directive('mapBoundsStateSetter', mapBoundsStateSetterComponent)
	.directive('mapReadySetter', mapReadySetterComponent)
	.directive('mapToCoordinatesPointer', mapToCoordinatesPointerComponent)
	.directive('shopHighlighter', shopHighlighter)
	.directive('shopMarkerClicker', shopMarkerClicker)
	.directive('shopMarkers', shopMarkersDirective)
	.directive('shopsInBounds', shopsInBoundsDirective)
	.directive('userLocationMarker', userLocationMarkerDirective)
	.service('mapHelperServ', MapHelperServ)
	.service('mapServ', MapServ)
	.name;